
const DONE_COLUMN = {
  key: "ukonczone",
  name: "Ukończone",
  hiddenByDefault: true,
};

const BASE_COLUMNS = [
  { key: "do_realizacji", name: "Do realizacji" },
  { key: "w_trakcie", name: "W trakcie" },
  { key: "do_poprawy", name: "Do poprawy" },
];

const REVIEW_COLUMN = { key: "do_sprawdzenia", name: "Do sprawdzenia", after: "w_trakcie" };

const EXTRA_COLUMNS = {
  mappers: [REVIEW_COLUMN],
  modelers_skins: [REVIEW_COLUMN],
  modelers_vehicles: [REVIEW_COLUMN],
  handling: [REVIEW_COLUMN],
  wiki: [REVIEW_COLUMN],
};

export function columnsFor(category) {
  const columns = [...BASE_COLUMNS];
  for (const extra of EXTRA_COLUMNS[category] || []) {
    const at = columns.findIndex((k) => k.key === extra.after);
    columns.splice(at + 1, 0, extra);
  }
  return [...columns, DONE_COLUMN];
}

export const ALL_COLUMNS = (() => {
  const columns = [...BASE_COLUMNS];
  for (const extra of Object.values(EXTRA_COLUMNS).flat()) {
    if (columns.some((k) => k.key === extra.key)) continue;
    const at = columns.findIndex((k) => k.key === extra.after);
    columns.splice(at + 1, 0, extra);
  }
  return [...columns, DONE_COLUMN];
})();

export const ALL_STATUSES = [
  ...BASE_COLUMNS.map((k) => k.key),
  ...Object.values(EXTRA_COLUMNS).flat().map((k) => k.key),
  DONE_COLUMN.key,
];
